import { brandLabels, brands, type BrandType } from 'noddi-types';
import { cn, NoddiIcon } from 'noddi-ui-common';
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from 'noddi-ui-web/src/base/command';
import { useEffect, useRef } from 'react';
import { getBrandLogo } from '../Brand/getBrandLogo';

interface Props {
  currentBrand: BrandType;
  onSelect: (brand: BrandType) => void;
  onDone: () => void;
}

const brandOptions = Object.entries(brands)
  .map(([id]) => ({ id: id as BrandType, name: brandLabels[id as BrandType] }))
  .sort((a, b) => a.name.localeCompare(b.name));

export function BrandThemePicker({ currentBrand, onSelect, onDone }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <Command label='Brand themes'>
      <CommandInput ref={inputRef} placeholder='Search brand themes…' aria-label='Search brand themes' />
      <CommandList aria-label='Brand themes'>
        <CommandEmpty>No brand themes found</CommandEmpty>
        {brandOptions.map((brand) => (
          <CommandItem
            key={brand.id}
            value={brand.id}
            keywords={[brand.name, 'theme', 'brand']}
            onSelect={() => {
              onSelect(brand.id);
              onDone();
            }}
          >
            <NoddiIcon name='Check' size='small' className={cn(brand.id !== currentBrand && 'opacity-0')} />
            <div className='flex size-5 shrink-0 items-center justify-center'>{getBrandLogo({ brand: brand.id })}</div>
            {brand.name}
            {brand.id === currentBrand && <span className='sr-only'>Current theme</span>}
          </CommandItem>
        ))}
      </CommandList>
    </Command>
  );
}
